<style lang="scss" scoped>
.course-list {
  color: #606266;
}
.operations {
  text-align: right;
}
</style>

<template>
  <div class="course-list">
    <div class="container fr-aic fr-jcsb">
      <comp-tab :data="[{ label: '全部', value: 0 }, { label: '报名中', value: 1 }, { label: '已停止', value: 2 }]" v-model="status" />
      <el-button style="height: 34px;" type="primary" size="small" @click="$router.push({ name: 'course-edit' })">创建课程</el-button>
    </div>

    <div class="container">
      <el-form :inline="true" class="demo-form-inline" size="mini">
        <el-form-item label="课程ID">
          <el-input class="input-width" placeholder="请输入课程ID" v-model="params.id"></el-input>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input class="input-width" placeholder="请输入课程名称" v-model="params.name"></el-input>
        </el-form-item>
      </el-form>

      <el-button @click="search" size="small">筛选</el-button>
      <el-button @click="clear" :disabled="!this.params.id && !this.params.name" style="color: #4E759E;" size="small" type="text">清空筛选条件</el-button>
    </div>

    <div class="container">
      <el-table :data="list">
        <el-table-column prop="id" label="课程ID" width="100px"></el-table-column>
        <el-table-column prop="name" label="课程名称"></el-table-column>
        <el-table-column label="课程价格(元)" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.amount / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开课时间">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.begintime * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结课时间">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.endtime * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="截止报名日期">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.applyendtime * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)" size="small" type="text">编辑</el-button>
            <el-button @click="onViewSignUp(scope.row)" size="small" type="text">查看报名</el-button>
            <el-button v-show="scope.row.applyendtime > parseInt(Date.now() / 1000)" @click="() => onStopSignUp(scope.row)" size="small" type="text">停止报名</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="container" style="text-align: center;">
      <el-button type="primary" size="small" :disabled="noMore" @click="() => query()">加载更多</el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import tab from '../../../components/tab/index';
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
import moment from 'moment';

export default {
  components: {
    'comp-tab': tab
  },
  data() {
    return {
      token: getToken(),
      status: 0,
      params: {
        id: '',
        name: '',
        count: 20,
        idlessthan: 0
      },
      list: [],
      noMore: false
    };
  },
  watch: {
    status() {
      this.list = [];
      this.query();
    }
  },
  mounted() {
    this.query();
  },
  methods: {
    clear() {
      this.params = {
        id: '',
        name: '',
        count: 20,
        idlessthan: 0
      };
      this.list = [];
      this.query();
    },
    search() {
      this.list = [];
      this.query();
    },
    query() {
      this.noMore = false;
      this.params.applyendtimegreaterthan = 0;
      this.params.applyendtimelessthan = 0;
      if (this.status === 1) {
        this.params.applyendtimegreaterthan = parseInt(new Date().getTime() / 1000);
      }
      if (this.status === 2) {
        this.params.applyendtimelessthan = parseInt(new Date().getTime() / 1000);
      }
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      rpc(
        'StoreCourseService.GetCourseList',
        M('CourseListQueryRequest', {
          ...this.params,
          token: M('Token', { token: this.token })
        })
      ).then(res => {
        const list = res.courselistList;
        if (!list.length) {
          this.$message({
            message: '没有更多了',
            type: 'info'
          });
          this.noMore = true;
          return;
        }
        this.list = this.list.concat(list);
      });
    },
    onEdit(course) {
      this.$router.push({
        name: 'course-edit',
        query: {
          id: course.id
        }
      });
    },
    onViewSignUp(course) {
      this.$router.push({
        name: 'course-records',
        query: {
          coursename: course.name
        }
      });
    },
    onStopSignUp(course) {
      rpc(
        'StoreCourseService.UpdateCourse',
        M('CourseWithTokenRequest', {
          token: M('Token', { token: this.token }),
          course: M('Course', {
            ...course,
            applyendtime: parseInt(Date.now() / 1000) - 1
          })
        })
      ).then(res => {
        if (res) {
          this.list.splice(this.list.findIndex(v => v.id == res.id), 1, res);
        }
      });
    }
  }
};
</script>
